require('./scoringRulesBrowser.i18n.json');
require('./scoringRulesBrowser.tpl.html');
require('./scoringRulesRepository.js');

/*@ngInject*/
const ScoringRulesBrowserController = function ($rootScope, $scope, $timeout, $state, dateUtil, $filter, localization, coreConstant, configurationActionsUtil, configurationMediator, databaseDownloadSectionName, navigationStateModel, sectionTemplateAction, modalUtil, userMediator, dataSetUtil, scoringRuleActions, coreMediator) {

    $scope.viewModel = {
        isLoading: true,
        scoringRules: [],
        categoryList: [],
        selectedCategoryList: [],
        selectedCategoryIds: [],
        categoryName: 'scoringFolder',
        totalScoringRules: 0,
        isGridEmpty: true,
        nameSearchString: '',
        requestParams: {
            key: 'name',
            startIndex: 0,
            pageSize: 25,
            sortType: 'asc',
            selectedCategoryList: []
        },
        shortDateFormat: coreMediator.getPreferenceByName('view.shortDateFormat'),
        searchDelayInMilliSeconds: 750
    };

    localization.getTranslationByKey('scoringRulesBrowser').then(function (translations) {
        $scope.viewModel.recordCountText = _.get(translations, 'recordCountText');
        $scope.viewModel.recordsCountText = _.get(translations, 'recordsCountText');
        $scope.viewModel.namePromptMessage = _.get(translations, 'namePromptMessage');
        $scope.viewModel.categoriesPromptMessage = _.get(translations, 'categoriesPromptMessage');
        $scope.viewModel.clearAll = _.get(translations, 'clearAll');

        $scope.actions = [];
        $scope.context = {
            identifier: 'scoringRulesBrowser',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            configurationMediator.loadScoringRulesActions().then(function (actions) {
                const allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.actions = allActions;

                $scope.actionsTimeLastModified = new Date().getTime();
            });
        }

        function loadScoringRules() {
            const viewModel = userMediator.restoreViewState('configuration.scoringRulesBrowser', $scope.viewModel);
            if (!_.isNil(viewModel)) {
                $scope.viewModel = viewModel;
            }

            $scope.viewModel.selectedCategoryList = _.join($scope.viewModel.selectedCategoryIds, '::');
            $scope.viewModel.requestParams.nameSearchString = $scope.viewModel.nameSearchString;
            $scope.viewModel.requestParams.selectedCategoryList = $scope.viewModel.selectedCategoryIds

            $scope.viewModel.isLoading = true;

            configurationMediator.getScoringRulesByParam($scope.viewModel.requestParams).then(function (scoringRules) {
                $scope.viewModel.scoringRules = scoringRules.records;
                $scope.viewModel.totalScoringRules = scoringRules.totalRecords;
                $scope.viewModel.isGridEmpty = $scope.viewModel.totalScoringRules === 0;

                $timeout(function () {
                    $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
                    $scope.viewModel.isLoading = false;
                }, 0);
            });
        }

        function loadCategoryList() {
            dataSetUtil.getDataSet({name: 'Scoring Rule Folders'}).then((dataset) => {
                $scope.viewModel.categoryList = dataset.items;
            });
        }

        $scope.getEffectiveDates = function (item) {
            const effectiveDateRangeBegin = $filter('utcDateFilter')(item.effectiveDateRangeBegin, $scope.viewModel.shortDateFormat);
            const to = $scope.getToString(item);
            const effectiveDateRangeEnd = $filter('utcDateFilter')(item.effectiveDateRangeEnd, $scope.viewModel.shortDateFormat);

            return `${effectiveDateRangeBegin} ${to} ${effectiveDateRangeEnd}`;
        };

        $scope.getToString = function (item) {
            return (!_.isNil(item.effectiveDateRangeBegin) && !_.isNil(item.effectiveDateRangeEnd)) ? ' ' + _.get(translations, 'to') + ' ' : ' '
        };

        /*
         * debounce is called here explicitly instead of using
         * "ng-model-options={debounce}" so that the debounce timer
         * can be cancelled. See the clearSearch function below.
         */
        $scope.searchChange = _.debounce(function () {
            userMediator.saveViewState('configuration.scoringRulesBrowser', {nameSearchString: $scope.viewModel.nameSearchString});
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
        }, $scope.viewModel.searchDelayInMilliSeconds);

        $scope.onPagingChange = function ($event, params) {
            $scope.viewModel.requestParams.startIndex = params.startIndex;
            loadScoringRules();
        };

        $scope.onSortChange = function (event, params) {
            $scope.viewModel.requestParams.key = params.key;
            $scope.viewModel.requestParams.sortType = params.sortType;
            userMediator.saveViewState('configuration.scoringRulesBrowser', $scope.viewModel);
            loadScoringRules();
        };

        function resetNavigationState() {
            navigationStateModel.saveViewState('configuration.scoringRulesBrowser', null);
        }

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case scoringRuleActions.CREATE:
                        $state.go('configuration.manageScoringRules', {scoringRuleId: -1});
                        break;
                    case scoringRuleActions.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.SCORING, _.get(translations, 'backup.name'),
                            _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;
                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.onClickRow = function (event, item) {
            $state.go('configuration.manageScoringRules', {scoringRuleId: item.id});
            navigationStateModel.saveViewState('configuration.scoringRulesBrowser', null);
        };

        $scope.clearSearch = function () {
            /*
             * The call to searchChange.cancel handles the scenario where
             * the user types some text in the search box, and then clicks
             * the clear button before the debounce timer goes off. Without
             * that call, the scoring rules are fetched twice, once as
             * a result of this method, with nameSearchString='', and
             * then again when the debounce timer goes off, with nameSearchString
             * set to the text typed in the search box, which effectively
             * undoes the click of the clear button. With that call,
             * the debounce timer is cancelled and the search box is cleared.
             */
            $scope.searchChange.cancel();
            /*
             * It is necessary to clear $scope.viewModel.selectedCategoryIds
             * as well as clearing selectedCategoryIds in the view-state
             * because userMediator.restoreViewState merges those two arrays.
             */
            $scope.viewModel.selectedCategoryIds = [];
            userMediator.saveViewState('configuration.scoringRulesBrowser',
                {
                    selectedCategoryIds: [],
                    nameSearchString: ''
                });
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
        };

        $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
            $scope.viewModel.selectedCategoryIds = [];

            _.each($scope.viewModel.categoryList, function (category) {
                if (category.selected) {
                    $scope.viewModel.selectedCategoryIds.push(category.value);
                }
            });

            $scope.viewModel.selectedCategoryList = _.join($scope.viewModel.selectedCategoryIds, '::');
            userMediator.saveViewState('configuration.scoringRulesBrowser', {selectedCategoryIds: $scope.viewModel.selectedCategoryIds});
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
        });

        $scope.$on('$destroy', function () {
            userMediator.saveViewState('configuration.scoringRulesBrowser', $scope.viewModel);
        });

        loadCategoryList();
        loadActions();
        loadScoringRules();
        resetNavigationState();
    });

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
        $scope.$apply();
    });
};

angular.module('ums.configuration')
    .controller('scoringRulesBrowserController', ScoringRulesBrowserController);

